import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("prodimmo_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("prodimmo_cookie_consent", "accepted");
    setShow(false);
  };

  const decline = () => {
    localStorage.setItem("prodimmo_cookie_consent", "declined");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 25 }}
          data-testid="cookie-consent"
          className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-slate-200 shadow-2xl shadow-black/10 px-4 py-4 md:px-8 md:py-5"
        >
          <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <p className="text-sm text-slate-700 leading-relaxed">
                Ce site utilise Google Fonts et Google Analytics pour améliorer votre expérience.
                En continuant, vous acceptez l'utilisation de ces services.
              </p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={decline}
                data-testid="cookie-decline"
                className="text-sm text-slate-500 hover:text-slate-700 font-medium transition-colors px-4 py-2"
              >
                Refuser
              </button>
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="bg-[#73B5E2] text-white hover:bg-[#5AA0D0] rounded-full px-6 py-2 text-sm font-medium transition-all hover:scale-105"
              >
                Accepter
              </button>
            </div>
            <button onClick={decline} className="absolute top-3 right-3 sm:hidden text-slate-400">
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
